/* Atribuição da jornada de candidatura.
   O visitante sai de ginastee.com/apply para o formulário no ActiveCampaign e
   volta em ginastee.com/apply/thanks. Os cookies do Pixel (_fbp/_fbc) sobrevivem
   por serem do nosso domínio, e aqui guardamos os parâmetros de clique para
   reenviá-los ao formulário e ao evento de Lead. */

const STORAGE_KEY = "ginastee:apply-attribution";

const TRACKED_PARAMS = [
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "ttclid",
  "msclkid",
];

function readStorage(storage) {
  try {
    const raw = window[storage]?.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function writeStorage(storage, value) {
  try {
    window[storage]?.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    /* modo privado ou storage indisponível: seguimos sem persistir */
  }
}

export function readAttribution() {
  if (typeof window === "undefined") return {};
  return readStorage("localStorage") || readStorage("sessionStorage") || {};
}

/* Idempotente: parâmetros novos da URL atual sobrescrevem os guardados. */
export function captureAttribution() {
  if (typeof window === "undefined") return {};

  const stored = readAttribution();
  const params = new URLSearchParams(window.location.search);
  const captured = { ...stored };
  let hasNewClick = false;

  TRACKED_PARAMS.forEach((param) => {
    const value = params.get(param);
    if (value) {
      captured[param] = value;
      hasNewClick = true;
    }
  });

  if (hasNewClick || !captured.capturedAt) {
    captured.capturedAt = Date.now();
    captured.landingUrl = window.location.href;
    captured.referrer = document.referrer || captured.referrer || "";
  }

  writeStorage("localStorage", captured);
  writeStorage("sessionStorage", captured);

  return captured;
}

export function appendAttributionToUrl(url, attribution = readAttribution()) {
  try {
    const target = new URL(url);
    TRACKED_PARAMS.forEach((param) => {
      if (attribution[param] && !target.searchParams.has(param)) {
        target.searchParams.set(param, attribution[param]);
      }
    });
    return target.toString();
  } catch (error) {
    return url;
  }
}

/* Parâmetros de campanha em formato achatado, para acompanhar os eventos. */
export function attributionEventParams(attribution = readAttribution()) {
  return TRACKED_PARAMS.reduce((params, key) => {
    if (attribution[key]) params[key] = attribution[key];
    return params;
  }, {});
}
